import { RunConfigService } from '@nuskin/ns-util'
import { CurrencyService } from '@nuskin/ns-shop'
import Decimal from 'decimal.js'

/**
 * Formats the given loyalty points value to the currency format of the given market.
 * @param {number} points loyalty points value
 * @return {string}
 */
export const formatPoints = (points = 0) => {
    const market = RunConfigService.getRunConfig().country
    const currency = CurrencyService.getCurrency(market)
    const accuracy = currency.accuracy || 2
    const truncatedPoints = Decimal(points).toDecimalPlaces(parseInt(accuracy)).toNumber()
    return CurrencyService.format(truncatedPoints, market)
}
